import { defaultHttpClient } from '../../httpClient';
import type { GoodsLegalNoticeResponse } from './types';

/**
 * - 상품 법적 고지 정보 조회 API
 * - GET /api/v2/goods/{sno}/legal_notice/
 */
export const getGoodsLegalNotice = (goodsSno: number) => {
  return defaultHttpClient
    .request<GoodsLegalNoticeResponse>({
      method: 'GET',
      url: `/api/v2/goods/${goodsSno}/legal_notice/`,
    })
    .then(result => result.data);
};